import styled from 'styled-components';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  margin: 0 0 1rem 0;

  .ant-descriptions-row > td {
    padding-bottom: 0.5rem;
  }
`;

export const Title = styled.span`
  margin-right: 1rem;
`;
